// extracted by mini-css-extract-plugin
module.exports = {"separator":"SeparatorGy_separator__LTnvn"};